import { render, staticRenderFns } from "./storeLists.vue?vue&type=template&id=650810bb&scoped=true&"
import script from "./storeLists.vue?vue&type=script&lang=js&"
export * from "./storeLists.vue?vue&type=script&lang=js&"
import style0 from "./storeLists.vue?vue&type=style&index=0&id=650810bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650810bb",
  null
  
)

export default component.exports